@if (event(); as ev) {
  <div class="npdc-title">
    <hgroup>
      <h1>{{ title() }}</h1>
      <p>{{ ev.content.eventDate | slice: 0 : 10 }}</p>
    </hgroup>
    <div class="npdc-title__actions">
      <button mat-icon-button [matMenuTriggerFor]="optionsMenu" matTooltip="More actions">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </div>

  <p>
    <a routerLink="/plankton/occurrence" [queryParams]="{ eventID: ev.id }">
      Show {{ ev.occurrenceCount }} related
      @if (ev.occurrenceCount === 1) {
        occurrence
      } @else {
        occurrences
      }
    </a>
  </p>

  <mat-card class="npdc-leaflet" appearance="outlined">
    <app-leaflet-group [geometry]="geometry()"></app-leaflet-group>
  </mat-card>

  <app-plankton-propertylist [data]="ev.content" title="Event data"></app-plankton-propertylist>
  <app-plankton-propertylist
    [data]="ev.measurementsOrFacts"
    title="Event measurementsOrFacts"
  ></app-plankton-propertylist>

  <mat-menu #optionsMenu>
    @if (ev.occurrenceCount) {
      <button
        mat-menu-item
        [routerLink]="['/plankton', 'occurrence']"
        [queryParams]="{ eventID: ev.id }"
      >
        <mat-icon>list</mat-icon> Show {{ ev.occurrenceCount }}
        @if (ev.occurrenceCount === 1) {
          occurrence
        } @else {
          occurrences
        }
      </button>
    }
    <a mat-menu-item href="{{ kinkoHost }}/plankton/event/{{ ev.id }}" target="_blank">
      <mat-icon>download</mat-icon> Download as JSON
    </a>
    @if (authService.user(); as user) {
      @if (user.accessLevel === 'admin') {
        <button mat-menu-item [routerLink]="['/plankton', 'origin', ev.originID]">
          <mat-icon>info</mat-icon> Show origin
        </button>
        <a mat-menu-item href="{{ kinkoHost }}/plankton/event/{{ ev.id }}?log=true" target="_blank">
          <mat-icon>info</mat-icon> Show detailed JSON
        </a>
      }
    }
  </mat-menu>
}
